// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux
import { get } from 'lodash';
import { getFieldIdByUuid } from 'fields/selectors';
import { getFieldViewTileUrlForFieldImage } from 'imagery/selectors';

// Action Types

export const typePrefix = 'vra/imagery/';
export const actions = [
  'STORE_ALL_FIELD_HEALTH_IMAGES_FOR_FIELD',
  'STORE_ALL_SSURGO_IMAGES_FOR_FIELD',
  'STORE_ALL_SOIL_SAMPLE_IMAGES_FOR_FIELD',
  'STORE_ALL_NONSAT_IMAGES_FOR_FIELD',
  'STORE_ALL_FV_IMAGES_FOR_FIELD',
  'STORE_ALL_IMPORTED_MAPS_IMAGES_FOR_FIELD',
  'STORE_FV_LEGEND_FOR_IMAGE',
  'EDIT_FV_IMAGE_URL',

  // analytics
  'OVERLAY_DESELECT',
  'OVERLAY_SELECT'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducer
export default function reducer(
  state = {},
  action = {}
) {
  // The imagery has a nested structure ( [fieldId][type][dateForImage] )
  let fieldId;
  let payload = action.payload;
  switch (action.type) {
    case actions.STORE_ALL_FIELD_HEALTH_IMAGES_FOR_FIELD:
      fieldId = payload.fieldId;
      return {
        ...state,
        [fieldId]: { ...state[fieldId], ...payload.images}
      };

    case actions.STORE_ALL_SSURGO_IMAGES_FOR_FIELD:
      fieldId = payload.fieldId;
      return {
        ...state,
        [fieldId]: { ...state[fieldId], ...payload.images}
      };

    case actions.STORE_ALL_SOIL_SAMPLE_IMAGES_FOR_FIELD:
      fieldId = payload.fieldId;
      return {
        ...state,
        [fieldId]: { ...state[fieldId], ...payload.images}
      };

    case actions.STORE_ALL_NONSAT_IMAGES_FOR_FIELD:
      fieldId = payload.fieldId;
      return {
        ...state,
        [fieldId]: { ...state[fieldId], ...payload.images}
      };

    case actions.STORE_ALL_FV_IMAGES_FOR_FIELD:
      fieldId = payload.fieldId;
      return {
        ...state,
        [fieldId]: { ...state[fieldId], ...payload.images}
      };

    case actions.STORE_ALL_IMPORTED_MAPS_IMAGES_FOR_FIELD:
      fieldId = payload.fieldId;
      return {
        ...state,
        [fieldId]: { ...state[fieldId], ...payload.images}
      };

    case actions.STORE_FV_LEGEND_FOR_IMAGE:
      fieldId = payload.fieldId;
      return { // TODO either normalize or nest in another reducer
        ...state,
        [fieldId]: {
          ...state[fieldId],
          [payload.layer]: {
            ...state[fieldId][payload.layer],
            [payload.overlayUuid]: {
              ...state[fieldId][payload.layer][payload.overlayUuid],
              legend: payload.legend
            }
          }
        }
      };

    case actions.EDIT_FV_IMAGE_URL:
      fieldId = payload.fieldId;
      return { 
        ...state,
        [fieldId]: {
          ...state[fieldId],
          [payload.layer]: {
            ...state[fieldId][payload.layer],
            [payload.overlayUuid]: {
              ...state[fieldId][payload.layer][payload.overlayUuid],
              url: payload.url
            }
          }
        }
      };
    default:
      return state;
  }
}

// Action Creators
// Assumes no field will have multiple sets of imagery
export const storeAllFieldHealthImagesForField = (fieldId, images) => {
  return {
    type: actions.STORE_ALL_FIELD_HEALTH_IMAGES_FOR_FIELD,
    payload: { images, fieldId }
  };
};

export const storeAllSsurgoImagesForField = (fieldId, images) => {
  return {
    type: actions.STORE_ALL_SSURGO_IMAGES_FOR_FIELD,
    payload: { images, fieldId }
  };
};

export const storeAllSoilSampleImagesForField = (fieldId, images) => {
  return {
    type: actions.STORE_ALL_SOIL_SAMPLE_IMAGES_FOR_FIELD,
    payload: { images, fieldId }
  };
};

export const storeAllNonSatImagesForField = (fieldId, images) => {
  return {
    type: actions.STORE_ALL_NONSAT_IMAGES_FOR_FIELD,
    payload: { images, fieldId }
  };
};

export const updateFieldViewUrlForImage = ({ fieldUuid, fieldId, overlayUuid, layer, cacheBuster }) => {
  return (dispatch, getState) => {
    const state = getState();
    fieldId = fieldId || getFieldIdByUuid(state, fieldUuid); // FV doesn't include fieldId
    let url = getFieldViewTileUrlForFieldImage(state, fieldId, fieldUuid, layer, overlayUuid);
    if (get(state,`imagery.${fieldId}.${layer}`) && url) {
      const cacheBusterQuery = `cacheBuster=${cacheBuster}`;
      url = url.includes('cacheBuster') ? url.replace(/cacheBuster.*$/i, cacheBusterQuery) 
        : `${url}&${cacheBusterQuery}`;
      dispatch({
        type: actions.EDIT_FV_IMAGE_URL,
        payload: { fieldId, overlayUuid, layer, url }
      });
    }
  };
};

export const storeAllFieldViewImagesForField = ({fieldUuid, fieldId, images}) => {
  return (dispatch, getState) => {
    const state = getState();
    fieldId = fieldId || getFieldIdByUuid(state, fieldUuid); // FV doesn't include fieldId
    dispatch({
      type: actions.STORE_ALL_FV_IMAGES_FOR_FIELD,
      payload: { images, fieldId }
    });
  };
};

export const storeFieldViewLegendForImage = ({ fieldUuid, fieldId, overlayUuid, legend, layer }) => {
  return (dispatch, getState) => {
    const state = getState();
    fieldId = fieldId || getFieldIdByUuid(state, fieldUuid); // FV doesn't include fieldId
    dispatch({
      type: actions.STORE_FV_LEGEND_FOR_IMAGE,
      payload: { fieldId, overlayUuid, legend, layer }
    });
  };
};

export const storeAllImportedMapsImagesForField = (fieldId, images) => {
  return {
    type: actions.STORE_ALL_IMPORTED_MAPS_IMAGES_FOR_FIELD,
    payload: { images, fieldId }
  };
};
